import { createFileRoute } from '@tanstack/react-router';
import HomePage from '~/containers/HomePage';

export const Route = createFileRoute('/home')({
  component: HomePage,
  validateSearch(search): { feature?: string } {
    return {
      feature: (search.feature as string) || undefined,
    };
  },
});
